import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12 mb-4" };
const _hoisted_5 = {
    class: "btn-group w-100 p-1 bg-light rounded",
    role: "group"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = ["disabled"];
const _hoisted_11 = { class: "col-md-12" };
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_14 = ["placeholder", "disabled"];
const _hoisted_15 = { class: "col-md-6" };
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "col-md-6" };
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_20 = { class: "col-md-12" };
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = { key: 1 };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = { class: "mt-3" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = {
    key: 1,
    class: "col-md-12"
};
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_30 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = { class: "position-relative" };
const _hoisted_33 = {
    key: 2,
    class: "col-md-12"
};
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_35 = {
    key: 0,
    class: "alert alert-info"
};
const _hoisted_36 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_37 = ["onClick", "title"];
const _hoisted_38 = { class: "col-md-12" };
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_40 = { class: "row g-2" };
const _hoisted_41 = { class: "col-6" };
const _hoisted_42 = ["type", "disabled"];
const _hoisted_43 = { class: "col-6" };
const _hoisted_44 = ["type", "disabled"];
const _hoisted_45 = { class: "text-muted" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { key: 1 };
const _hoisted_48 = {
    key: 3,
    class: "col-md-12"
};
const _hoisted_49 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_50 = { class: "card-body" };
const _hoisted_51 = { class: "row" };
const _hoisted_52 = { class: "col-md-6 mb-2" };
const _hoisted_53 = { class: "badge bg-primary ms-2" };
const _hoisted_54 = {
    key: 0,
    class: "col-md-6 mb-2"
};
const _hoisted_55 = { class: "badge bg-success ms-2" };
const _hoisted_56 = {
    key: 4,
    class: "col-md-12"
};
const _hoisted_57 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_58 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
                onSubmit: _cache[20] || (_cache[20] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.createNewCategorie && _ctx.createNewCategorie(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "btn-check",
                                name: "campaignType",
                                id: "typeEmail",
                                value: "email",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedType) = $event)),
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 8, _hoisted_6), [
                                [_vModelRadio, _ctx.selectedType]
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("label", {
                                class: "btn btn-outline-primary border-0 rounded",
                                for: "typeEmail"
                            }, [
                                _createElementVNode("i", { class: "fas fa-envelope me-2" }),
                                _createTextVNode(" Email Campaign ")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "btn-check",
                                name: "campaignType",
                                id: "typePush",
                                value: "push",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedType) = $event)),
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 8, _hoisted_7), [
                                [_vModelRadio, _ctx.selectedType]
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("label", {
                                class: "btn btn-outline-primary border-0 rounded",
                                for: "typePush"
                            }, [
                                _createElementVNode("i", { class: "fas fa-mobile-alt me-2" }),
                                _createTextVNode(" Push Notification ")
                            ], -1))
                        ])
                    ]),
                    (_ctx.selectedType === 'email')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Objet de l'email * ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: "Ex: Profitez de -20% sur votre prochaine pizza !",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.campaignData.subject) = $event)),
                                    required: "",
                                    disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                                }, null, 8, _hoisted_10), [
                                    [_vModelText, _ctx.campaignData.subject]
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.selectedType === 'push' ? 'Titre de la notification *' : 'Nom de la campagne (interne) *'), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.selectedType === 'push' ? 'Ex: Pizzas à moitié prix !' : 'Ex: Newsletter Mars 2024',
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.campaignData.title) = $event)),
                                required: "",
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 8, _hoisted_14), [
                                [_vModelText, _ctx.campaignData.title]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Audience cible *", -1)),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select shadow-none rounded-0",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.campaignData.target_filters.audience_type) = $event)),
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("option", { value: "all_active" }, "Tous les clients actifs", -1),
                                    _createElementVNode("option", { value: "newsletter" }, "Abonnés Newsletter uniquement", -1)
                                ]))], 8, _hoisted_17), [
                                [_vModelSelect, _ctx.campaignData.target_filters.audience_type]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Périmètre géographique *", -1)),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.restaurantSelected,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.restaurantSelected) = $event)),
                                options: _ctx.originalRestaurant,
                                label: "name",
                                reduce: (restaurant) => restaurant.id,
                                placeholder: "Global (Tous les restaurants)",
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 8, ["modelValue", "options", "reduce", "disabled"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Contenu du message *", -1)),
                            (_ctx.selectedType === 'email')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_ctx.actionDetected == _ctx.ActionCrud.EDIT)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "ql-editor border rounded bg-light",
                                            style: { "min-height": "200px" },
                                            innerHTML: _ctx.campaignData.content
                                        }, null, 8, _hoisted_23))
                                        : (_openBlock(), _createBlock(_component_QuillEditor, {
                                            key: 1,
                                            theme: "snow",
                                            "content-type": "html",
                                            toolbar: _ctx.customToolbar,
                                            content: _ctx.campaignData.content,
                                            "onUpdate:content": _cache[6] || (_cache[6] = ($event) => ((_ctx.campaignData.content) = $event))
                                        }, null, 8, ["toolbar", "content"]))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        class: "form-control shadow-none rounded-0 text-black",
                                        rows: "4",
                                        placeholder: "Écrivez ici votre message push...",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.campaignData.content) = $event)),
                                        required: "",
                                        disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                                    }, null, 8, _hoisted_25), [
                                        [_vModelText, _ctx.campaignData.content]
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Image de la notification (Optionnel)", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "url",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "Lien vers une image (https://...)",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.campaignData.image_url) = $event)),
                                            disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                                        }, null, 8, _hoisted_27), [
                                            [_vModelText, _ctx.campaignData.image_url]
                                        ])
                                    ])
                                ]))
                        ])
                    ]),
                    (_ctx.sendingType == _ctx.$t('lists.campaignTypes.individual'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('forms.recipients')) + " * ", 1),
                                (_ctx.actionDetected != _ctx.ActionCrud.EDIT)
                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                        key: 0,
                                        modelValue: _ctx.userSelected,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.userSelected) = $event)),
                                        options: _ctx.originalUsers,
                                        label: "email",
                                        reduce: (user) => user.email
                                    }, null, 8, ["modelValue", "options", "reduce"]))
                                    : _createCommentVNode("", true),
                                (_ctx.actionDetected != _ctx.ActionCrud.EDIT)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        onClick: _cache[10] || (_cache[10] =
                                            //@ts-ignore
                                            (...args) => (_ctx.addUserToDestination && _ctx.addUserToDestination(...args))),
                                        class: "bg-transparent p-0 border-0 mt-2 text-warning lh-1 fw-medium",
                                        disabled: !_ctx.userSelected
                                    }, [
                                        _cache[29] || (_cache[29] = _createElementVNode("i", { class: "flaticon-users-group lh-1 me-1 position-relative top-2" }, null, -1)),
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('lists.addToCampaign')), 1)
                                    ], 8, _hoisted_31))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.categorieData.destination.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                (_ctx.actionDetected != _ctx.ActionCrud.EDIT)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-info-circle me-2" }, null, -1)),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.categorieData.destination.length), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.selectedRecipients')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_36, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.showAllRecipients ? _ctx.categorieData.destination : _ctx.categorieData.destination.slice(0, 3)), (email, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                            key: index,
                                            class: "badge bg-primary d-flex align-items-center"
                                        }, [
                                            _createTextVNode(_toDisplayString(email) + " ", 1),
                                            (_ctx.actionDetected != _ctx.ActionCrud.EDIT)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "btn-close btn-close-white ms-2",
                                                    onClick: ($event) => (_ctx.removeDestination(index)),
                                                    title: _ctx.$t('lists.removeRecipient')
                                                }, null, 8, _hoisted_37))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128)),
                                    (!_ctx.showAllRecipients && _ctx.categorieData.destination.length > 3)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "badge bg-warning cursor-pointer d-flex align-items-center",
                                            style: { "cursor": "pointer" },
                                            onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.showAllRecipients = true))
                                        }, " + " + _toDisplayString(_ctx.categorieData.destination.length - 3) + " " + _toDisplayString(_ctx.$t('common.more') || 'plus'), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.showAllRecipients && _ctx.categorieData.destination.length > 3)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "badge bg-secondary cursor-pointer d-flex align-items-center",
                                            style: { "cursor": "pointer" },
                                            onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.showAllRecipients = false))
                                        }, _toDisplayString(_ctx.$t('common.seeLess') || 'Voir moins'), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Planifier l'envoi (optionnel) ", -1)),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: _ctx.dateFieldType,
                                        class: "form-control shadow-none rounded-0 text-black w-100",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.scheduledDate) = $event)),
                                        disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT,
                                        placeholder: "jj/mm/aaaa",
                                        onFocus: _cache[14] || (_cache[14] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleDateFocus && _ctx.handleDateFocus(...args))),
                                        onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.dateFieldType = _ctx.scheduledDate ? 'date' : 'text'))
                                    }, null, 40, _hoisted_42), [
                                        [_vModelDynamic, _ctx.scheduledDate]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: _ctx.timeFieldType,
                                        class: "form-control shadow-none rounded-0 text-black w-100",
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.scheduledTime) = $event)),
                                        disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT,
                                        placeholder: "--:--",
                                        onFocus: _cache[17] || (_cache[17] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleTimeFocus && _ctx.handleTimeFocus(...args))),
                                        onBlur: _cache[18] || (_cache[18] = ($event) => (_ctx.timeFieldType = _ctx.scheduledTime ? 'time' : 'text'))
                                    }, null, 40, _hoisted_44), [
                                        [_vModelDynamic, _ctx.scheduledTime]
                                    ])
                                ])
                            ]),
                            _createElementVNode("small", _hoisted_45, [
                                _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                                (_ctx.actionDetected == _ctx.ActionCrud.EDIT)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Date planifiée de la campagne "))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, " Laissez vide pour envoyer immédiatement "))
                            ])
                        ])
                    ]),
                    (_ctx.actionDetected == _ctx.ActionCrud.EDIT && _ctx.categorieResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "card-title mb-3" }, [
                                        _createElementVNode("i", { class: "fas fa-chart-bar me-2" }),
                                        _createTextVNode(" Statistiques de la campagne ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("div", _hoisted_52, [
                                            _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Nombre de destinataires :", -1)),
                                            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.categorieResponse.recipientsCount || _ctx.categorieData.destination.length), 1)
                                        ]),
                                        (_ctx.categorieResponse.deliveredCount !== undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                _cache[34] || (_cache[34] = _createElementVNode("strong", null, "Livrés :", -1)),
                                                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.categorieResponse.deliveredCount || 0), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.actionDetected == _ctx.ActionCrud.ADD || (_ctx.actionDetected == _ctx.ActionCrud.EDIT && _ctx.campaignData.status === 'draft'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected == _ctx.ActionCrud.ADD ? 'Envoyer la campagne' : 'Lancer le brouillon'), 11, _hoisted_58)),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[19] || (_cache[19] =
                                        //@ts-ignore
                                        (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                    class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                }, [...(_cache[36] || (_cache[36] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                                        _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                                    ]))])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 32)
        ])
    ]));
}
